{
  "09fd2948a8dffd21": "Lugar de trabajo",
  "1509f561f2416598": "Guardar",
  "15b7a1e2d83541fd": "Registrar cambio de propiedad",
  "180951fbef616064": "Esto elimina el nuevo propietario registrado y la fecha efectiva de {{name}}. Puedes registrar un nuevo cambio de propietario más tarde.",
  "19766ed6ccb2f4a3": "Cancelar",
  "1cf8bc7ff36fdae7": "Nuevo propietario",
  "1d94141ca61f4cfb": "Nueva instalación",
  "2abe42b8023a7cd7": "Registrar cambio de propiedad",
  "2c3e315dca1ab8e7": "No se pudo eliminar el cambio de propietario. Por favor, inténtalo de nuevo o contacta con soporte.",
  "4895f73177ab5d67": "No establecido",
  "6031ee797185af1e": "Comience a escribir el nombre del lugar de trabajo...",
  "7753397c2f7de806": "No se pudo guardar el cambio de propietario. Por favor, inténtalo de nuevo o contacta con soporte.",
  "819fd46786737578": "Actualizar cambio de propiedad",
  "8328c521afbe2b1d": "¿Eliminar cambio de propietario?",
  "8c3339684176b8f0": "Lugar de trabajo del nuevo propietario",
  "a4068889867e0d25": "Fecha de efectividad",
  "c1c1009d3f37ec05": "Actualizar",
  "c3812fc4acb861d5": "Eliminar",
  "cc2111dd92b635db": "Buscando lugares de trabajo...",
  "cd63c7df0fec232f": "Fecha inválida",
  "e87ced5e089eba2b": "ID: {{id}}",
  "ecce85ce8e6acc28": "Eliminar cambio de propietario",
  "efb1b9fb7d251ac7": "Dirección no disponible"
}
